import { useEffect } from 'react';

import qs from 'query-string';
import { concat } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { StringParam, useQueryParam } from 'use-query-params';

import { getPath } from 'constants/routes';
import { setShowMobileInfo } from 'store/app';
import { guestPortalIdSelector } from 'store/app/selectors';
import { accountIdSelector } from 'store/user/selectors';
import axiosApi from 'utils/axios';

import { clearGPViewed, getGPViewed, setGPViewed } from '../functions';
import { GP_LANDING_ROUTE } from './constants';

export const useGuestPortalRouteBuilder = () => {
  const params = useParams();

  const getGuestPortalPath = (id) => {
    return getPath(GP_LANDING_ROUTE, { ...params, itemId: id, itemType: 'guest-portal' });
  };
  const getItineraryPath = (id) => {
    return getPath(GP_LANDING_ROUTE, { ...params, itemId: id, itemType: 'itinerary' });
  };

  const buildRoute = (route, queryParams = {}) => {
    const queryString = qs.stringify(queryParams);
    return concat(getPath(route, params), queryString ? `?${queryString}` : '');
  };

  return {
    getGuestPortalPath,
    getItineraryPath,
    buildRoute,
  };
};

export const useGPViewed = () => {
  const id = useSelector(guestPortalIdSelector);
  const accountId = useSelector(accountIdSelector);

  useEffect(() => {
    if (getGPViewed(id) !== 'true' && localStorage.getItem('pdfPreview') !== 'true') {
      setGPViewed(id);

      axiosApi.post(`/acc/${accountId}/guest_portals/${id}/view`);
    }

    return () => {
      clearGPViewed(id);
    };
  }, []);
};

export const useGPUnViewed = () => {
  const { guestPortalId: id } = useParams();

  useEffect(() => {
    clearGPViewed(id);
  }, []);
};

export function useRedirectUrlForGettingShowMobileInfo() {
  const [redirectUri] = useQueryParam('redirect_uri', StringParam);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!redirectUri) {
      dispatch(setShowMobileInfo(true));

      return;
    }

    const url = new URL(redirectUri);
    const parts = url.pathname.split('/');
    const accessId = parts[parts.length - 1];

    if (!accessId) return;

    axiosApi
      .get(`/guest_portals/accesses/${accessId}`)
      .then((data) => {
        dispatch(setShowMobileInfo(data.data.showMobileInfo));
      })
      .catch((err) => console.error(err));
  }, [dispatch, redirectUri]);
}
